const translations: Record<string, string> = {
  'common:siteName': 'Ferramentas PDF Grátis',
  'common:nav.home': 'Início',
  'common:nav.pdfToWord': 'PDF para Word',
  'common:nav.pdfToExcel': 'PDF para Excel',
  'common:nav.pdfToPpt': 'PDF para PPT',
  'common:nav.imageConvert': 'Converter Imagem',
  'common:nav.pdfTools': 'Ferramentas PDF',
  'common:nav.tutorials': 'Tutoriais',
  'common:nav.faq': 'Perguntas Frequentes',

  'common:footer.description': 'As melhores ferramentas PDF gratuitas para todas as suas necessidades. Sem registro.',
  'common:footer.quickLinks': 'Links Rápidos',
  'common:footer.about': 'Sobre',
  'common:footer.aboutUs': 'Sobre Nós',
  'common:footer.tutorials': 'Tutoriais',
  'common:footer.faq': 'Perguntas Frequentes',
  'common:footer.privacyPolicy': 'Política de Privacidade',
  'common:footer.subscribe': 'Newsletter',
  'common:footer.subscribeNote': 'Receba as últimas dicas e atualizações.',
  'common:footer.subscribePlaceholder': 'Digite seu e-mail',
  'common:footer.subscribeButton': 'Assinar',
  'common:footer.subscribing': 'Assinando...',
  'common:footer.subscribeSuccess': '✓ Assinado com sucesso!',
  'common:footer.subscribeFailed': 'Falha ao assinar, tente novamente.',
  'common:footer.subscribeError': 'Erro de rede, tente novamente.',
  'common:footer.adSpace': 'Espaço Publicitário',
  'common:footer.copyright': '© 2024 Ferramentas PDF Grátis. Todos os direitos reservados.',

  'common:features.pdfToDoc': 'PDF para Documentos',
  'common:features.pdfToDocDesc': 'Converta PDF para Word, Excel, PPT e mais formatos editáveis.',
  'common:features.imageToPdf': 'Imagem para PDF',
  'common:features.imageToPdfDesc': 'Combine várias imagens em um único arquivo PDF facilmente.',
  'common:features.pdfMerge': 'Mesclar e Dividir PDF',
  'common:features.pdfMergeDesc': 'Mescle vários PDFs ou divida um PDF em arquivos separados.',
  'common:features.startConvert': 'Iniciar Conversão',
  'common:features.useNow': 'Usar Agora',
  'common:features.mostPopular': 'Mais Popular',

  'home:hero.title': 'Ferramentas PDF Grátis Online',
  'home:hero.subtitle': 'Converta, edite e gerencie seus arquivos PDF facilmente. Sem registro, 100% grátis!',
  'home:hero.free': 'Grátis Para Sempre',
  'home:hero.noRegistration': 'Sem Registro',
  'home:hero.secure': 'Seguro e Privado',
  'home:hero.startConverting': 'Começar a Converter',
  'home:hero.viewAllTools': 'Ver Todas as Ferramentas',
  'home:hero.stats.users': 'Usuários Satisfeitos',
  'home:hero.stats.conversions': 'Arquivos Convertidos',
  'home:hero.stats.rating': 'Avaliação dos Usuários',

  'home:allTools.title': 'Todas as Ferramentas PDF',
  'home:allTools.subtitle': 'Tudo que você precisa para trabalhar com arquivos PDF, completamente grátis.',
  'home:allTools.tryNow': 'Experimentar Agora',
  'home:tools.pdfToWord.name': 'PDF para Word',
  'home:tools.pdfToWord.description': 'Converta PDF para documentos Word editáveis.',
  'home:tools.pdfToExcel.name': 'PDF para Excel',
  'home:tools.pdfToExcel.description': 'Extraia tabelas de PDF para planilhas Excel.',
  'home:tools.pdfToPpt.name': 'PDF para PPT',
  'home:tools.pdfToPpt.description': 'Transforme PDF em apresentações PowerPoint.',
  'home:tools.pdfToImage.name': 'PDF para Imagem',
  'home:tools.pdfToImage.description': 'Converta páginas PDF para imagens JPG ou PNG.',
  'home:tools.imageToPdf.name': 'Imagem para PDF',
  'home:tools.imageToPdf.description': 'Combine imagens em um único arquivo PDF.',
  'home:tools.mergePdf.name': 'Mesclar PDF',
  'home:tools.mergePdf.description': 'Combine vários arquivos PDF em um.',
  'home:tools.splitPdf.name': 'Dividir PDF',
  'home:tools.splitPdf.description': 'Extraia páginas de um arquivo PDF.',
  'home:tools.compressPdf.name': 'Comprimir PDF',
  'home:tools.compressPdf.description': 'Reduza o tamanho do arquivo PDF sem perder qualidade.',

  'home:whyUs.title': 'Por Que Nos Escolher?',
  'home:whyUs.subtitle': 'Oferecemos as melhores ferramentas PDF gratuitas sem taxas ocultas ou registro.',
  'home:whyUs.free.title': '100% Grátis',
  'home:whyUs.free.description': 'Todas as ferramentas são completamente gratuitas. Sem taxas ocultas.',
  'home:whyUs.fast.title': 'Ultra Rápido',
  'home:whyUs.fast.description': 'Nossos servidores processam seus arquivos em segundos.',
  'home:whyUs.secure.title': 'Seguro e Privado',
  'home:whyUs.secure.description': 'Seus arquivos são excluídos automaticamente após a conversão.',
  'home:whyUs.easy.title': 'Fácil de Usar',
  'home:whyUs.easy.description': 'Interface simples de arrastar e soltar, sem habilidades técnicas.',
  'home:whyUs.cta.title': 'Pronto para Começar?',
  'home:whyUs.cta.description': 'Junte-se a milhões de usuários que confiam em nossas ferramentas PDF gratuitas.',
  'home:whyUs.cta.button': 'Experimentar Grátis Agora',

  'home:testimonials.title': 'O Que os Usuários Dizem',
  'home:testimonials.subtitle': 'Confiado por milhões de usuários em todo o mundo.',
  'home:testimonials.trustedBy': 'Confiado e certificado por',
  'home:testimonials.badges.secure': 'SSL Seguro',
  'home:testimonials.badges.verified': 'Verificado Seguro',
  'home:testimonials.badges.award': 'Ferramenta Top',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': 'Gerente de Marketing',
  'home:testimonials.user1.content': 'Esta é a melhor ferramenta PDF gratuita que já usei. Rápida, confiável e sem registro chato!',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': 'Designer Freelance',
  'home:testimonials.user2.content': 'Converto PDFs para Word todos os dias para meus clientes. Esta ferramenta economiza muito tempo e é completamente grátis!',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': 'Analista de Negócios',
  'home:testimonials.user3.content': 'O recurso PDF para Excel é incrivelmente preciso. Extrai tabelas perfeitamente toda vez.',

  'home:ads.topBanner': 'Publicidade',
  'home:ads.middleBanner': 'Publicidade',

  'upload:dragDrop': 'Arraste e solte seu arquivo PDF aqui',
  'upload:or': 'ou',
  'upload:selectFile': 'Selecionar Arquivo',
  'upload:processing': 'Processando...',
  'upload:converting': 'Convertendo seu arquivo...',
  'upload:done': 'Concluído!',
  'upload:success': 'Seu arquivo foi convertido com sucesso',
  'upload:download': 'Baixar Arquivo',
  'upload:convertAnother': 'Converter Outro Arquivo',
  'upload:fileSize': 'Tamanho máximo do arquivo: 10MB',
  'upload:supportedFormats': 'Formatos suportados',

  'pdfToWord:title': 'PDF para Word',
  'pdfToWord:description': 'Converta seus arquivos PDF em documentos Word editáveis gratuitamente',
  'pdfToWord:feature1.title': 'Conversão Rápida',
  'pdfToWord:feature1.desc': 'Converta PDF para Word em segundos',
  'pdfToWord:feature2.title': 'Alta Qualidade',
  'pdfToWord:feature2.desc': 'Preserve a formatação e layout originais',
  'pdfToWord:feature3.title': '100% Grátis',
  'pdfToWord:feature3.desc': 'Sem registro ou pagamento necessário',
  'pdfToWord:howTo.title': 'Como Usar',
  'pdfToWord:howTo.step1': 'Envie seu arquivo PDF',
  'pdfToWord:howTo.step2': 'Aguarde a conversão',
  'pdfToWord:howTo.step3': 'Baixe seu arquivo Word',

  'pdfToExcel:title': 'PDF para Excel',
  'pdfToExcel:description': 'Converta tabelas PDF em planilhas Excel editáveis',
  'pdfToExcel:feature1.title': 'Extrair Tabelas',
  'pdfToExcel:feature1.desc': 'Extraia tabelas de PDF automaticamente',
  'pdfToExcel:feature2.title': 'Dados Precisos',
  'pdfToExcel:feature2.desc': 'Preserve a estrutura de dados original',
  'pdfToExcel:feature3.title': 'Fácil de Usar',
  'pdfToExcel:feature3.desc': 'Interface simples e intuitiva',
  'pdfToExcel:howTo.title': 'Como Usar',
  'pdfToExcel:howTo.step1': 'Envie arquivo PDF com tabelas',
  'pdfToExcel:howTo.step2': 'O sistema extrairá as tabelas',
  'pdfToExcel:howTo.step3': 'Baixe seu arquivo Excel',

  'pdfToPpt:title': 'PDF para PowerPoint',
  'pdfToPpt:description': 'Transforme seu PDF em apresentações PowerPoint editáveis',
  'pdfToPpt:feature1.title': 'Conversão de Slides',
  'pdfToPpt:feature1.desc': 'Cada página PDF se torna um slide PPT',
  'pdfToPpt:feature2.title': 'Editável',
  'pdfToPpt:feature2.desc': 'Edite texto e imagens após a conversão',
  'pdfToPpt:feature3.title': 'Seguro e Privado',
  'pdfToPpt:feature3.desc': 'Seus arquivos são excluídos após a conversão',
  'pdfToPpt:howTo.title': 'Como Usar',
  'pdfToPpt:howTo.step1': 'Selecione seu arquivo PDF',
  'pdfToPpt:howTo.step2': 'Converta para formato PPT',
  'pdfToPpt:howTo.step3': 'Baixe sua apresentação',

  'imageConvert:title': 'Conversor de Imagens',
  'imageConvert:description': 'Converta imagens para PDF ou PDF para imagens facilmente',
  'imageConvert:feature1.title': 'Multi-Formato',
  'imageConvert:feature1.desc': 'Suporta JPG, PNG, BMP, GIF',
  'imageConvert:feature2.title': 'Conversão em Lote',
  'imageConvert:feature2.desc': 'Converta várias imagens de uma vez',
  'imageConvert:feature3.title': 'Qualidade Preservada',
  'imageConvert:feature3.desc': 'Sem perda de qualidade de imagem',
  'imageConvert:howTo.title': 'Como Usar',
  'imageConvert:howTo.step1': 'Envie imagens ou PDF',
  'imageConvert:howTo.step2': 'Escolha o formato de saída',
  'imageConvert:howTo.step3': 'Baixe arquivos convertidos',

  'pdfToolsPage:title': 'Ferramentas PDF Completas',
  'pdfToolsPage:description': 'Mescle, divida, comprima e edite seus arquivos PDF',
  'pdfToolsPage:feature1.title': 'Mesclar PDF',
  'pdfToolsPage:feature1.desc': 'Combine vários PDFs em um',
  'pdfToolsPage:feature2.title': 'Dividir PDF',
  'pdfToolsPage:feature2.desc': 'Extraia páginas de PDF',
  'pdfToolsPage:feature3.title': 'Comprimir PDF',
  'pdfToolsPage:feature3.desc': 'Reduza o tamanho do arquivo PDF',
  'pdfToolsPage:howTo.title': 'Como Usar',
  'pdfToolsPage:howTo.step1': 'Escolha a ferramenta que você precisa',
  'pdfToolsPage:howTo.step2': 'Envie seu arquivo PDF',
  'pdfToolsPage:howTo.step3': 'Baixe o resultado processado',

  'upload.dragDrop': 'Arraste e solte seu arquivo PDF aqui',
  'upload.or': 'ou',
  'upload.selectFile': 'Selecionar arquivo PDF',
  'upload.fileSize': 'Tamanho máximo do arquivo: 20MB',
  'upload.uploading': 'Enviando...',
  'upload.processing': 'Processando...',
  'upload.converting': 'Convertendo...',
  'upload.preparing': 'Preparando download...',
  'upload.done': 'Conversão concluída!',
  'upload.download': 'Baixar',
  'upload.convertAnother': 'Converter outro arquivo',
  'upload.convertedTo': 'Convertido para',
  'upload.error': 'Conversão falhou',
  'upload.retry': 'Tentar novamente',
  'upload.selectAnother': 'Selecionar outro arquivo',
  'upload.fileTooLarge': 'O tamanho do arquivo excede o limite de 20MB',
  'upload.invalidFormat': 'Formato de arquivo inválido',
  'upload.networkError': 'Erro de rede, por favor tente novamente',
  'upload.conversionFailed': 'Conversão falhou, por favor tente novamente',
  'upload.howItWorks': 'Como funciona',
  'upload.step1': 'Enviar arquivo',
  'upload.step1Desc': 'Selecione ou arraste seu arquivo PDF',
  'upload.step2': 'Converter',
  'upload.step2Desc': 'Processamos seu arquivo automaticamente',
  'upload.step3': 'Baixar',
  'upload.step3Desc': 'Obtenha seu arquivo convertido instantaneamente',
  'upload.downloading': 'Preparando download...',
  'upload.progress': 'Progresso: {percent}%',

  'imageConvert.pdfToImage': 'PDF para Imagem',
  'imageConvert.imageToPdf': 'Imagem para PDF',
  'imageConvert.selectImages': 'Selecionar Imagens',
  'imageConvert.multipleFilesHint': 'Suporta várias imagens mescladas em um PDF',
  'imageConvert.processingFiles': 'Processando {count} arquivos...',

  'pdfToPpt.feature1': 'Preservar Layout',
  'pdfToPpt.feature2': 'Manter Imagens',
  'pdfToPpt.feature3': 'Apresentação Editável',
};

export default translations;
